const firebaseConfig = {
  apiKey: "AIzaSyCTh4vEPYibTKdY3Vxwq6c5IUx4H4pgFLw",
  authDomain: "earn-2018.firebaseapp.com",
  databaseURL: "https://earn-2018.firebaseio.com",
  projectId: "earn-2018",
  storageBucket: "earn-2018.appspot.com",
  messagingSenderId: "807276711190",
  appId: "1:807276711190:web:64f0ebc0c8d91d81011437"
  };
  export default firebaseConfig;